import React, { useEffect } from 'react'
import { useForm } from '../../forms/hocs/form.context'
import { setSearchId } from '../../utils/set-search-id'
import { useATTrackInteraction } from '@at/consumer-web-snowplow'
import { PILLS_CONTAINER_ID } from '../../constants/ids'
import { useObserveScreenWidth } from '../../hooks/use-observe-screen-width.hook'
import { FilterPillsDesktop } from './filter-pills-desktop'
import { FilterPillsMobile } from './filter-pills-mobile'

export const FilterPills = () => {
    const { clearSearch, localFilterPills, setLocalFilterPills } = useForm()
    const { isMobile } = useObserveScreenWidth()

    const filterPillLength = localFilterPills?.reduce((sum, facetGroup) => sum + facetGroup.pills.length, 0) || 0
    const isFilterSelected = filterPillLength > 0

    const firstAddedPillLabel = localFilterPills?.[0]?.pills?.[0]?.label

    useEffect(() => {
        const filterPillContainer = document.getElementById(PILLS_CONTAINER_ID)

        if (filterPillContainer && firstAddedPillLabel) {
            filterPillContainer.scrollTo({ left: 0, behavior: 'smooth' })
        }
    }, [firstAddedPillLabel])

    const trackClearAllFilters = useATTrackInteraction({
        trackingLabel: `clear-all-filters-filter-pill`,
    })

    const handleClearAllButton = () => {
        clearSearch()
        setLocalFilterPills([])
        trackClearAllFilters()
        window.scrollTo(0, 0)
        setSearchId()
    }

    const props = {
        filterPillLength,
        handleClearAllButton,
        isFilterSelected,
    }

    return isMobile ? <FilterPillsMobile {...props} /> : <FilterPillsDesktop {...props} />
}
